import { configureStore } from '@reduxjs/toolkit';
import fieldsSlice from '../features/fields/fieldsSlice';
import quoteSlice from '../features/quote/quoteSlice';
import uiSlice from '../features/ui/uiSlice';

export const store = configureStore({
  reducer: {
    ui:uiSlice,
    fields: fieldsSlice,
    quote: quoteSlice
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
});
